import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "50%",
        x2: "50%",
        y1: "100%",
        y2: "0%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#1267EF"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#0BEADE"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#a)",
      "fill-rule": "nonzero",
      d: "M7.5 0Q0 0 0 7.5T7.5 15 15 7.5 7.5 0m1.207 10.493c-.19.695-.916.516-1.108.36-.07-.057-.51-.576-.99-1.14a1 1 0 0 1-.323.057H4.922a.93.93 0 0 1-.93-.93V6.511c0-.514.416-.93.93-.93h1.364q.167.001.317.055c.468-.551.904-1.055 1.004-1.134.164-.129.825-.38 1.083.342.047.134.382 1.33.382 2.635-.002 1.435-.338 2.91-.365 3.013m2.103-1.235c-.154.358-.482.477-.648.308-.17-.17-.178-.482-.076-.727a2.79 2.79 0 0 0 0-2.174c-.102-.243-.093-.558.076-.729.167-.169.494-.048.648.31a3.85 3.85 0 0 1 0 3.012"
    }, null, -1)
  ])))
}
export default { render: render }